import React, { Component, Fragment } from "react";
import _ from "lodash";
import Delayed from "../Delayed";
import Detail from "../Detail";
import Form from "../Form";
class ShowModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }

  show() {
    this.setState({ show: true });
  }

  hide() {
    this.setState({ show: false });
  }

  getComponent() {
    const props = _.pick(this.props, [
      "model",
      "id",
      "belongsTo",
      "props",
      "title",
      "disabled",
      "customerId",
      "init",
    ]);

    if (this.props.type === "detail") {
      return (
        <Detail
          {...props}
          hide={() => {
            this.hide();
          }}
        />
      );
    }

    if (this.props.type === "form") {
      return (
        <Form
          {...props}
          layout="vertical"
          hide={() => {
            this.hide();
          }}
          root={true}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <Fragment>
        <span
          onClick={() => {
            this.show();
          }}
        >
          {this.props.children}
        </span>
        <Delayed mounted={this.state.show} unmountAfter={300}>
          {this.getComponent()}
        </Delayed>
      </Fragment>
    );
  }
}

export default ShowModal;



// WEBPACK FOOTER //
// ./src/containers/ShowModal/index.js